export const categorySuggestions = (tree, term, selected = []) => {
  const query = term.trim().toLowerCase();
  if (!query) return [];
  const seen = new Set(selected.map(value => value.toLowerCase()));
  const results = [];
  const walk = (node, path = []) => {
    const entries = Array.isArray(node) ? node.map(value => [value, null]) : Object.entries(node || {});
    for (const [value, children] of entries) {
      const key = value.toLowerCase();
      if (path.length && key.includes(query) && !seen.has(key)) {
        seen.add(key);
        results.push({ topLevel: path[0], level: path.length === 1 ? 'second' : 'third', parent: path.slice(1).join(' > '), value });
      }
      if (children) walk(children, [...path, value]);
    }
  };
  walk(tree);
  return results.sort((a, b) => Number(b.value.toLowerCase() === query) - Number(a.value.toLowerCase() === query)).slice(0, 10);
};
